module.exports = __webpack_public_path__ + "static/media/image-card-6.52bc8785.png";